/**
 * useHeuteRenewals — TanStack Query hook for the Heute Fälligkeiten block (Story V10-J).
 *
 * live mode → GET /renewals/heute via the typed client (RenewalHeuteDto — no reshape).
 * mock mode → resolves MOCK_HEUTE_RENEWALS (mock layer NOT deleted).
 *
 * [Source: apps/web/src/features/dashboard/heute-renewals-mock.ts] (wire-swap path note)
 * [Source: docs/stories/v10-j-web-wiring-core.md AC2]
 */

import { useQuery } from '@tanstack/react-query';
import type { RenewalHeuteDto } from '@brokly/shared';
import { qk } from '../../../lib/query-keys';
import { isLiveData } from '../../../lib/data-mode';
import { apiClient } from '../../../lib/api-client';
import { MOCK_HEUTE_RENEWALS } from '../heute-renewals-mock';

export function useHeuteRenewals() {
  const live = isLiveData();
  return useQuery<RenewalHeuteDto>({
    queryKey: qk.renewalsHeute(),
    queryFn: () => (live ? apiClient.renewals.heute() : Promise.resolve(MOCK_HEUTE_RENEWALS)),
    // mock mode: synchronous initialData (no loading flicker, deterministic tests)
    ...(live ? {} : { initialData: MOCK_HEUTE_RENEWALS, staleTime: Infinity }),
  });
}
